// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"af866a48","162":"83a26289","387":"af842146","472":"a05fdcb2","578":"6309c764","581":"6d5f3db1","667":"cab4aefc","788":"de215a89","920":"09961cb5"}[chunkId] + ".chunk.css";
};